module.exports = "<div class=\"shelfProductTagCenter\">\r\n    <a ng-if=\"::$ctrl.product.CentreTag.TagLink\" ng-href=\"{{::$ctrl.product.CentreTag.TagLink}}\" ng-click=\"::$ctrl.tagClick($event)\">\r\n        <span ng-bind-html=\"::$ctrl.getTagContent()\"></span>\r\n    </a>\r\n    <span ng-if=\"::!$ctrl.product.CentreTag.TagLink\" ng-click=\"::$ctrl.staticTextClick($event)\" ng-bind-html=\"::$ctrl.getTagContent()\"></span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/shop/shelfproduct/shelf-product-tag/shelf-product-tag-center.component.html
// module id = 263
// module chunks = 0 1